import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';
import {
  getIsMobile,
  getHasJoinedWithEclipse,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { isEditorTextEmpty } from '@wix/da-shared-react/pkg/DaEditorWrapper/utils';
import { Props } from './AboutMe';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { AboutModuleType } from '../../../../types/papi';

export default connect(
  (state: AppState, ownProps: Props) => {
    const aboutMeData: AboutModuleType = getModuleData(
      state,
      ownProps.moduleId
    );
    const {
      isArtist,
      website,
      badges,
      socialLinks,
      textContent,
      countryId,
    } = aboutMeData;
    const hasSocialLinks = socialLinks && socialLinks.length > 0;
    const hasBadges = badges && badges.length > 0;
    const isMobile = getIsMobile(state);
    const isBioEmpty = isEditorTextEmpty(textContent);
    const isEmpty =
      (isMobile && !ownProps.isWide && isBioEmpty) || // TODO: this should be done in AboutMeBox.tsx
      (!isArtist &&
        !website &&
        !hasBadges &&
        !hasSocialLinks &&
        !textContent &&
        !countryId);

    return {
      ...aboutMeData,
      bio: textContent,
      user: getProfileOwnerUser(state),
      isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
      isEmpty,
      isMobile,
      withFTUE:
        isBioEmpty &&
        hasFirstTimeFlag(state, FirstTimeFlag.ProfileHeroAidNotClosed),
      hasJoinedWithEclipse: getHasJoinedWithEclipse(state),
    };
  },
  {}
);
